import * as PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Modal from '../Modal';

const PhysicianInvitePhysician = ({ onCancel, children }) => {
  const { t } = useTranslation('components');

  return (
    <Modal
      title={t('PhysicianInvitePhysician.title')}
      showCloseButton
      onClickCloseButton={onCancel}
      infoUrl="https://medflex.de/hilfe/behandler-kontakte/mit-kollegen-verbinden/"
    >
      <div className="mb-6 text-slate-800 lg:mr-16 text-sm lg:text-base">
        {t('PhysicianInvitePhysician.subtitle')}
      </div>
      {children}
    </Modal>
  );
};

PhysicianInvitePhysician.defaultProps = {
  onCancel: () => {},
  children: null,
};

PhysicianInvitePhysician.propTypes = {
  onCancel: PropTypes.func,
  children: PropTypes.node,
};

export default PhysicianInvitePhysician;
